import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  campuses: [],
  error: null,
};

export default function campusesReducer(state = initialState, action) {
  switch (action.type) {
    // 🔹 START REQUESTS
    case actionTypes.SAVE_CAMPUS_REQUEST:
    case actionTypes.UPDATE_CAMPUS_REQUEST:
    case actionTypes.DELETE_CAMPUS_REQUEST:
    case actionTypes.SAVE_CAMPUS_GALLERY_REQUEST:
    case actionTypes.UPDATE_CAMPUS_GALLERY_REQUEST:
    case actionTypes.DELETE_CAMPUS_GALLERY_REQUEST:
      return { ...state, loading: true, error: null };

    // 🔹 SAVE CAMPUS
    case actionTypes.SAVE_CAMPUS_SUCCESS:
      return {
        ...state,
        loading: false,
        campuses: [...state.campuses, action.payload],
      };

    // 🔹 UPDATE CAMPUS
    case actionTypes.UPDATE_CAMPUS_SUCCESS:
      return {
        ...state,
        loading: false,
        campuses: state.campuses.map((campus) =>
          campus.campusObjId === action.payload.campusObjId
            ? { ...campus, ...action.payload }
            : campus
        ),
      };

    // 🔹 DELETE CAMPUS
    case actionTypes.DELETE_CAMPUS_SUCCESS:
      return {
        ...state,
        loading: false,
        campuses: state.campuses.filter(
          (campus) => campus.campusObjId !== action.payload.campusObjId
        ),
      };

    // 🔹 SAVE CAMPUS GALLERY (Cover Image)
    case actionTypes.SAVE_CAMPUS_GALLERY_SUCCESS:
      return {
        ...state,
        loading: false,
        campuses: state.campuses.map((campus) =>
          campus.campusObjId === action.payload.campusObjId
            ? {
                ...campus,
                coverImage: action.payload.coverImage || action.payload.imageUrl,
                galleryObjId: action.payload.galleryObjId,
                campusGalleryObjId: action.payload.campusGalleryObjId,
                gallerySettings: {
                  mobile: action.payload.mobilesetting,
                  tablet: action.payload.tabletsetting,
                  dashboard: action.payload.dashboardsetting,
                  default: action.payload.default,
                },
              }
            : campus
        ),
      };

    // 🔹 UPDATE CAMPUS GALLERY (Cover Image)
    case actionTypes.UPDATE_CAMPUS_GALLERY_SUCCESS:
      return {
        ...state,
        loading: false,
        campuses: state.campuses.map((campus) =>
          campus.campusObjId === action.payload.campusObjId
            ? {
                ...campus,
                coverImage: action.payload.coverImage || action.payload.imageUrl,
                galleryObjId: action.payload.galleryObjId,
                campusGalleryObjId: action.payload.campusGalleryObjId,
                gallerySettings: {
                  mobile: action.payload.mobilesetting,
                  tablet: action.payload.tabletsetting,
                  dashboard: action.payload.dashboardsetting,
                  default: action.payload.default,
                },
              }
            : campus
        ),
      };
// 🔹 DELETE CAMPUS GALLERY (Cover Image)
case actionTypes.DELETE_CAMPUS_GALLERY_SUCCESS:
  return {
    ...state,
    loading: false,
    campuses: state.campuses.map((campus) =>
      campus.campusObjId === action.payload.campusObjId
        ? {
            ...campus,
            coverImage: null,
            galleryObjId: null,
            campusGalleryObjId: null,
            gallerySettings: {},
          }
        : campus
    ),
  };

    // 🔹 FAILURES
    case actionTypes.SAVE_CAMPUS_FAILURE:
    case actionTypes.UPDATE_CAMPUS_FAILURE:
    case actionTypes.DELETE_CAMPUS_FAILURE:
    case actionTypes.SAVE_CAMPUS_GALLERY_FAILURE:
    case actionTypes.UPDATE_CAMPUS_GALLERY_FAILURE:
      case actionTypes.DELETE_CAMPUS_GALLERY_FAILURE:

      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
